<template>
  <div>
    <h4>CONTROL DE POLLO</h4>
    <table class="table table-bordered table-sm">
      <tr>
        <td>RESTO DEL DIA ANTERIOR</td>
        <TdForm v-model="resto"></TdForm>
      </tr>
      <tr>
        <td>COMPRA DEL DIA</td>
        <TdForm v-model="compra"></TdForm>
      </tr>
      <tr v-show="loading">
        <td colspan="2">
          <i class="fas fa-spinner fa-spin"></i>
          Cargando ...
        </td>
      </tr>
      <!--<TrForm v-model="resto">RESTO DEL DIA ANTERIOR</TrForm>-->
      <!--<TrForm v-model="compra">COMPRA DEL DIA</TrForm>-->
      <template v-for="(l, i) in detalle">
        <tr :key="`${i}_`">
          <td>{{ l.categorie_name }}</td>
          <td
            @click="
              $refs.elModalDetail.show();
              $refs.elReportDetail.load(l.details);
            "
            class="text-center"
          >
            {{ l.chicken }}
            <i class="fas fa-info-circle"></i>
          </td>
        </tr>
      </template>
      <tr>
        <td>CONSUMO TOTAL</td>
        <td class="text-center">{{ consumo }}</td>
      </tr>
      <tr v-for="(l, i) in stockRelativo" :key="i">
        <td>{{ l.categorie_name }}</td>
        <td class="text-center">{{ l.chicken }}</td>
      </tr>
      <tr>
        <td>RESULTADO</td>
        <th class="text-center">{{ resultado }}</th>
      </tr>
    </table>

    <app-button-submit @oneClick="save()">Guardar Cambios</app-button-submit>
    <button class="btn btn-primary ml-1" @click="$refs.elPreRes.show()">
      <i class="fas fa-redo-alt"></i>
      Reiniciar
    </button>

    <app-modal-yn ref="elPreRes" @yes="reset()">
      <p>
        Seguro(a) de reiniciar?, esta operacion dejara todas las cantidades en
        cero
      </p>
    </app-modal-yn>

    <app-modal-basic ref="elModalDetail">
      <ReportDetail ref="elReportDetail"></ReportDetail>
    </app-modal-basic>
  </div>
</template>
<script>
import { DinnerService } from "../dinner-module/DinnerService";
import _ from "lodash";
// import TrForm from "../dinner-module/logistic/TrForm.vue";
import { myMoment, momentDateFormat } from "src/lt-module/utils/myMoment.js";
import { pollos, categories } from "./pollos.js";
import TdForm from "../dinner-module/logistic/TdForm.vue";
import ReportDetail from "./ReportDetail.vue";

export default {
  components: {
    // TrForm,
    TdForm,
    ReportDetail
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    resto: 0,
    compra: 0,
    consumo: 0,
    detalle: [],
    loading: false
  }),

  computed: {
    resultado() {
      return (
        parseFloat(this.resto) +
        parseFloat(this.compra) -
        parseFloat(this.consumo)
      );
    },
    stockRelativo() {
      return this.detalle.map((x) => {
        return {
          categorie_name: "STOCK " + x.categorie_name,
          chicken: _.round(
            ((parseFloat(this.resto) + parseFloat(this.compra)) *
              parseFloat(x.chicken)) /
              parseFloat(this.consumo) -
              parseFloat(x.chicken),
            3
          )
        };
      });
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    save() {
      DinnerService.saveLogisticHistory({
        // ...this.$data,
        resto: this.resto,
        compra: this.compra,
        consumo: this.consumo,
        detalle: this.detalle,
        //
        resultado: this.resultado,
        // entity_id: this.entityId
        cashRegisterId: this.$options.box.id
      }).then(() => {
        //
        window.alert("Cambios guardados");
      });
    },
    reset() {
      this.loading = true;
      var box = this.$options.box;
      Promise.all([
        DinnerService.getLastCashRegister(box.id),
        DinnerService.getReport(
          myMoment(box.created_at).format(momentDateFormat),
          box.entity_id
        )
      ]).then((res) => {
        var lastBox, report;
        [lastBox, report] = res;

        if (lastBox.adds && lastBox.adds.resultado) {
          this.resto = parseInt(lastBox.adds.resultado);
        }

        var preLoad = report
          .filter((row) => categories.includes(parseInt(row.categorie_id)))
          .map((row) => {
            row.chicken =
              parseFloat(row.quantity) * (pollos.get(row.product_id) || 0);
            return row;
          });

        this.detalle = Object.keys(_.groupBy(preLoad, "categorie")).map(
          (categorie) => {
            // console.log(categorie);
            return {
              categorie_name: categorie,
              details: preLoad.filter((x) => x.categorie == categorie),
              chicken: preLoad
                .filter((x) => x.categorie == categorie)
                .map((x) => x.chicken)
                .reduce((p, c) => p + c, 0)
            };
          }
        );

        this.consumo = this.detalle.reduce((p, c) => p + c.chicken, 0);
        this.loading = false;
      });
    },
    load(box) {
      this.$options.box = box;
      if (box.adds && box.adds.resultado) {
        this.resto = box.adds.resto;
        this.compra = box.adds.compra;
        this.consumo = box.adds.consumo;
        this.detalle = box.adds.detalle;
      } else {
        this.reset(box);
      }
    }
  }
};
</script>

<style scoped></style>
